module.exports = __webpack_public_path__ + "static/media/logo.932771b8.png";